export default "__VITE_ASSET__5ecbD2v4$b0nA3cmRuugqw__"